import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
      },
    theme: {
        dark: false,
        themes: {
            light:{
                primary: '#03a9f4',
                secondary: '#3f51b5',
                accent: '#607d8b',
                error: '#f44336',
                warning: '#ff5722',
                info: '#ffc107',
                success: '#8bc34a'
            },
            dark: {
                primary: colors.grey,
                secondary: colors.grey.darken3,
                accent: colors.shades.black,
                error: colors.red.accent3,
            },
        },
    },
})